/**
 * Utility for consistent logging across the application.
 * Logging can be disabled via REACT_APP_ENABLE_LOGGING environment variable.
 */

const isLoggingEnabled = process.env.REACT_APP_ENABLE_LOGGING !== 'false';

const logger = {
  info: (...args) => {
    if (isLoggingEnabled) {
      console.log(...args);
    }
  },
  
  error: (...args) => {
    if (isLoggingEnabled) {
      console.error(...args);
    }
  },
  
  warn: (...args) => {
    if (isLoggingEnabled) {
      console.warn(...args);
    }
  },
  
  debug: (...args) => {
    if (isLoggingEnabled && process.env.NODE_ENV === 'development') {
      console.debug(...args);
    }
  },

  // Add generic log method for compatibility
  log: (...args) => {
    if (isLoggingEnabled) {
      console.log(...args);
    }
  }
};

export default logger;
